import { render, staticRenderFns } from "./layout-menu-short.vue?vue&type=template&id=0f4f3b02"
import script from "./layout-menu-short.vue?vue&type=script&setup=true&lang=js"
export * from "./layout-menu-short.vue?vue&type=script&setup=true&lang=js"
import style0 from "./layout-menu-short.vue?vue&type=style&index=0&id=0f4f3b02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports